if (!customElements.get('welcome-discount-toast')) {
  customElements.define(
    'welcome-discount-toast',
    class WelcomeDiscountToast extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        if (window.location.pathname === '/challenge') return;

        this.closeButtons = this.querySelectorAll('[data-welcome-close]');
        this.form = this.querySelector('[data-welcome-form]');
        this.input = this.querySelector('[data-welcome-input]');
        this.initialState = this.querySelector('[data-welcome-initial-state]');
        this.successState = this.querySelector('[data-welcome-success-state]');
        this.copyButton = this.querySelector('[data-welcome-copy]');
        this.copyText = this.querySelector('[data-welcome-copy-text]');

        this.closeButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.dismiss();
          });
        });

        // Cerrar con la tecla ESC
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.classList.contains('is-visible')) {
            this.dismiss();
          }
        });

        // Copiar código de descuento
        if (this.copyButton) {
          this.copyButton.addEventListener('click', () => this.copyCode());
        }

        // Manejo del formulario
        if (this.form) {
          this.form.addEventListener('submit', (e) => this.handleSubmit(e));
        }

        if (window.Shopify && window.Shopify.designMode) {
          this.reveal();
          return;
        }

        // Si ya fue descartado o reclamado, no mostrar a menos que esté en modo prueba
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.schedule(this.delay);
          this.setupExitIntent();
        }
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay'), 10) : 4;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry'), 10) : 14;
      }

      get cookieName() {
        return this.getAttribute('data-cookie') || 'bracarli:welcome-discount';
      }

      get code() {
        return this.getAttribute('data-code') || 'BIENVENIDO5';
      }

      schedule(delay) {
        this.timer = window.setTimeout(() => this.reveal(), Math.max(delay, 0) * 1000);
      }

      setupExitIntent() {
        // En desktop: Si el usuario intenta salir hacia arriba antes del delay, saltar
        const handleExit = (e) => {
          if (e.clientY < 20 && !this.classList.contains('is-visible') && !this.dismissed) {
            window.clearTimeout(this.timer);
            this.reveal();
            document.removeEventListener('mouseleave', handleExit);
          }
        };
        document.addEventListener('mouseleave', handleExit, { once: true });
      }

      reveal() {
        if (this.dismissed && !this.testMode) return;
        this.hidden = false;
        requestAnimationFrame(() => {
          this.classList.add('is-visible');
        });
      }

      dismiss() {
        this.dismissed = true;
        this.classList.remove('is-visible');
        window.setTimeout(() => {
          this.hidden = true;
        }, 350);

        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      async handleSubmit(e) {
        e.preventDefault();
        const email = this.input ? this.input.value.trim() : '';
        if (!email || !email.includes('@') || !email.includes('.')) {
          if (this.input) {
            this.input.focus();
            this.input.style.borderColor = '#ef4444';
            setTimeout(() => {
              this.input.style.borderColor = '';
            }, 2000);
          }
          return;
        }

        const submitBtn = this.querySelector('[data-welcome-submit]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.7';
          submitBtn.textContent = 'Enviando...';
        }

        try {
          const formData = new FormData(this.form);
          // Envío nativo a Shopify Newsletter
          fetch('/contact#contact_form', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).catch(() => {});

          // Aplicar descuento silenciosamente a la sesión del carrito
          if (this.code) {
            fetch(`/discount/${encodeURIComponent(this.code)}`, {
              method: 'GET'
            }).catch(() => {});
          }

          // Guardar cookie permanente (30 días)
          this.setCookie(this.cookieName, 30);

          // Transición suave al estado de éxito
          if (this.initialState && this.successState) {
            this.initialState.classList.add('hidden');
            this.successState.classList.remove('hidden');
            this.successState.classList.add('flex');
          }
        } catch (err) {
          console.warn('Error al registrar correo', err);
          if (this.initialState && this.successState) {
            this.initialState.classList.add('hidden');
            this.successState.classList.remove('hidden');
            this.successState.classList.add('flex');
          }
        }
      }

      async copyCode() {
        const code = this.code;
        if (!code) return;

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
          }

          if (this.copyButton) this.copyButton.classList.add('is-copied');
          if (this.copyText) this.copyText.textContent = '¡Copiado! ✓';

          window.clearTimeout(this.copiedTimer);
          this.copiedTimer = window.setTimeout(() => {
            if (this.copyButton) this.copyButton.classList.remove('is-copied');
            if (this.copyText) this.copyText.textContent = 'Copiar';
          }, 2500);
        } catch (err) {
          console.warn('No se pudo copiar el código', err);
        }
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiryDays) {
        document.cookie = `${name}=true; max-age=${expiryDays * 24 * 60 * 60}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }
  );
}
